import { useTranslation } from 'react-i18next';

interface ComingSoonBannerProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  gradientFrom?: string;
  gradientTo?: string;
}

export function ComingSoonBanner({
  icon,
  title,
  description,
  gradientFrom = 'from-amber-500',
  gradientTo = 'to-orange-500',
}: ComingSoonBannerProps) {
  const { t } = useTranslation();

  return (
    <div className={`mb-6 bg-gradient-to-r ${gradientFrom} ${gradientTo} rounded-xl p-4 text-white shadow-lg`}>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          {icon}
        </div>
        <div>
          <h2 className="text-xl font-bold">{t('Coming Soon')}</h2>
          <p className="text-white/90">{t(description)}</p>
        </div>
      </div>
    </div>
  );
}
